import React, { Fragment, useEffect, useState } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate , useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { getDate, getItemFromStorage, setItemToStorage, userPicUrl } from "../../utils/Helper";
import { CustomerDetailsAction } from "../../Redux/Action/CustomerAction";
import { decodeID  , getLastURL } from "../../utils/Helper";




function CustomerView() {
    const dispatch = useDispatch<any>();
    const navigate = useNavigate()
    const log_in = useSelector((state: any) => state.CustomerDetailsState)
    const customerdata = useSelector((state: any) => state.CustomerDetailsState?.data?.data?.detail)
    const location = useLocation();
    const editId = getLastURL(location);
    const [loading  , setLoading] = useState(false)
    
    const handleBack = () => {
        setItemToStorage('customerdata', '')
        navigate('/customer-management-list')
    }
    useEffect(()=>{
        setLoading(true)
        var params = {
            detail_id: decodeID(editId)
        };
     dispatch(CustomerDetailsAction(params))
     setTimeout(() => {
        setLoading(false)
      }, 400);
    },[])

    let totalbooking = customerdata?.booking_details?.length
    let totalpending = customerdata?.booking_details.filter((res:any)=> res.status == "0")
    let totalcomeplete = customerdata?.booking_details.filter((res:any)=> res.status == "1")
    let totalcancel = customerdata?.booking_details.filter((res:any)=> res.status == "2")
    let totalNoshownup = customerdata?.booking_details.filter((res:any)=> res.status == "3")

    return (
        <Fragment>
            { loading ||  log_in?.loading ? <Spinner /> : ""}
            <PageLayout
                title="Customer Management"
                breadcrumbs={{
                    secLast: { 'link': '/customer-management-list', 'name': 'Customer Management' },
                }}
                buttons={[
                    { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
                ]}
            >
                <div className="card">
                    <div className="card-body">
                        <div className="row gy-4">
                        <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Customer Profile picture:</label>
                                    </div>
                                    <div className="col-md-9">
                                       <img src={userPicUrl(customerdata?.profile_pic)} alt="image" width={70} height={70} style={{borderRadius:"35px"}} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Customer ID:</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.id ? customerdata?.id : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Name</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.name ? customerdata?.name : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Mobile</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata ? `${customerdata?.phone_country_code || '--'}  ${customerdata.phone_number || '--'}` : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Gender</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.gender ? customerdata?.gender : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Email</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.email ? customerdata?.email : '--'}</span>
                                    </div>
                                </div>
                            </div>
                             <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Dob</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.dob ? customerdata?.dob : '--'}</span>
                                    </div>
                                </div>
                            </div> 
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Country</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.country == "null" ? "---" : customerdata?.country ? customerdata.country : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Bio</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.bio == "null" ? "--" : customerdata?.bio ? customerdata?.bio : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Status</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.status == "1" ? "Active" : "Inactive"}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label">Registration date</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{customerdata?.created_at ? getDate(customerdata?.created_at) : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label">Total Number Of Bookings</label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalbooking}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label">Total Number Of Completed Bookings</label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalcomeplete?.length}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label">Total Number Of Cancelled Bookings</label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalcancel?.length}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label">Total Number Of upcoming Bookings</label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalpending?.length}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="username" className="form-label">Total Number Of No Shows Bookings</label>
                                    </div>
                                    <div className="col-md-3">
                                        <span>{totalNoshownup?.length}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary waves-effect waves-light" onClick={() => handleBack()} >BACK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastDefault />
            </PageLayout>
        </Fragment>
    );
}

export default CustomerView;